import React from 'react';

/**
 * Calcule un score à partir d'une liste de questions répondue
 * @param {Array} questions - Liste d'objets contenant elapsed_time et nb_compass
 * @returns {number} Score total
 */
const ScoreComputer = ({ questions }) => {
  const K = 900;

  // Filtrer les questions valides
  const answeredQuestions = questions.filter(q => q.elapsed_time !== null && !q.aborted);

  if (answeredQuestions.length === 0) {
    return <>0</>;
  }

  // Somme des temps
  const totalTime = answeredQuestions.reduce((sum, q) => sum + q.elapsed_time, 0);

  // Total des boussoles restantes
  const totalCompass = answeredQuestions.reduce((sum, q) => sum + q.nb_compass, 0);

  // Calcul du score
  const scoreTime = 120 * Math.exp(-totalTime / K);
  const scoreCompass = (totalCompass / (3 * answeredQuestions.length)) * 30;

  const score = Math.round(scoreTime + scoreCompass);

  return <>{score}</>;
};

export default ScoreComputer;
